export const fetchNextMatche = async (clubId, startDate) => {
    const baseUrl = `https://api-dofa.fff.fr/api/clubs/${clubId}/matchs`;
    const params = new URLSearchParams({
        'ma_dat[after]': startDate, // Garder uniquement `ma_dat[after]`
        page: 1, // Pagination
    });

    try {
        // Appel API sans `before`
        const response = await fetch(`${baseUrl}?${params}`);
        if (!response.ok) {
            throw new Error("Failed to fetch match results");
        }
        const data = await response.json();

        // Filtrer uniquement les matchs pour "Régional 1 Futsal"
        const filteredMatches = data["hydra:member"].filter(match =>
            match.competition.name.toUpperCase().includes("D2 FUTSAL")
        );

        // Retourner les matchs filtrés
        return filteredMatches;
    } catch (error) {
        console.error("API Error:", error);
        return [];
    }
};


export const fetchMatchResults = async (clubId, startDate, endDate) => {
    const baseUrl = `https://api-dofa.fff.fr/api/clubs/${clubId}/matchs`;
    const params = new URLSearchParams({
        'ma_dat[after]': startDate,
        'ma_dat[before]': endDate,
        page: 1,
    });

    try {
        const response = await fetch(`${baseUrl}?${params}`);
        if (!response.ok) {
            throw new Error("Failed to fetch match results");
        }
        const data = await response.json();
        return data["hydra:member"];
    } catch (error) {
        console.error("API Error:", error);
        return [];
    }
};


export const fetchClubTeams = async (clubId) => {
    const baseUrl = `https://api-dofa.fff.fr/api/clubs/${clubId}/equipes`;

    try {
        const response = await fetch(baseUrl);
        if (!response.ok) {
            throw new Error("Failed to fetch club teams");
        }
        const data = await response.json();

        // Transformation des données reçues
        return data["hydra:member"].map((team) => ({
            id: team["@id"], // Identifiant de l'équipe
            name: team.category_label, // Nom de l'équipe
            shortName: team.short_name, // Nom court de l'équipe
            logo: team.club.logo, // Logo du club
            category: team.category_code, // Code de la catégorie
            categoryGender: team.category_gender, // Genre (M/F)
            engagements: team.engagements.map((engagement) => {
                const competitionId = engagement.competition["@id"].split("/").pop(); // Extraire l'ID de la compétition
                return {
                    competitionId, // ID de la compétition
                    competitionName: engagement.competition.name, // Nom de la compétition
                    competitionType: engagement.competition.type, // Type de compétition (CH, CP, etc.)
                    level: engagement.competition.level, // Niveau de la compétition
                    status: engagement.en_statut, // Statut de l'engagement (E pour engagé)
                    location: engagement.terrain ? engagement.terrain : "Non défini", // Terrain si disponible
                };
            }),
        }));
    } catch (error) {
        console.error("API Error:", error);
        return [];
    }
};



export const fetchTeamMatches = async (competitionId, phaseId, pouleId, clubId, page = 1) => {
    const baseUrl = `https://api-dofa.fff.fr/api/compets/${competitionId}/phases/${phaseId}/poules/${pouleId}/matchs?clNo=137104&page=1`;

    try {
        const response = await fetch(baseUrl);

        if (!response.ok) {
            throw new Error("Failed to fetch matches");
        }
        const data = await response.json();
        return data["hydra:member"]; // Liste des matchs
    } catch (error) {
        console.error("API Error:", error);
        return [];
    }
};

export const fetchRanking = async (competitionId, pouleId = 1) => {
    const apiUrl = `https://api-dofa.fff.fr/api/compets/${competitionId}/phases/1/poules/${pouleId}/classement_journees`;
    console.log(apiUrl);
    try {
        const response = await fetch(apiUrl);
        if (!response.ok) {
            throw new Error("Failed to fetch ranking");
        }
        const data = await response.json();
        return data["hydra:member"]; // Retourner uniquement les membres du classement
    } catch (error) {
        console.error("Erreur lors du chargement du classement :", error);
        return [];
    }
};



export const fetchNews = async (page) => {
    return new Promise((resolve) => {
        setTimeout(() => {
            const dummyNews = [
                {
                    id: `article-${page}-1`,
                    image: "https://via.placeholder.com/300x150",
                    title: `Actualité ${page}-1`,
                    date: "12 Juin 2024",
                    summary: "Résumé de l'actualité avec des informations importantes.",
                },
                {
                    id: `article-${page}-2`,
                    image: "https://via.placeholder.com/300x150",
                    title: `Actualité ${page}-2`,
                    date: "11 Juin 2024",
                    summary: "Découvrez plus d'informations sur cet événement clé.",
                },
            ];
            resolve(dummyNews);
        }, 1000); // Simulation de délai
    });
};


